export const CHANGE_UTILITY = "CHANGE_UTILITY";
export const SET_UTILITY = "SET_UTILITY";
export const FETCH_UTILITY_REQUEST = "FETCH_UTILITY_REQUEST";
export const FETCH_UTILITY_SUCCESS = "FETCH_UTILITY_SUCCESS";
export const FETCH_UTILITY_FAILURE = "FETCH_UTILITY_FAILURE";
